import gql from "graphql-tag";

export const ASSISTANT_MESSAGE_FIELDS = gql`
  fragment AssistantMessageFields on AssistantMessage {
    id
    role
    content
    created
  }
`;

export const ASSISTANT_CONVERSATION_QUERY = gql`
  query AssistantConversation($id: SmartID!) {
    assistantConversation(id: $id) {
      id
      isAwaitingTeam
      isThinking
      project {
        id
        name
      }
      messages {
        ...AssistantMessageFields
      }
    }
  }
  ${ASSISTANT_MESSAGE_FIELDS}
`;

export const ASSISTANT_CONVERSATIONS_QUERY = gql`
  query AssistantConversations {
    assistantConversations {
      id
      created
      isAwaitingTeam
      preview
      project {
        id
        name
      }
    }
  }
`;

export const ASK_ASSISTANT_MUTATION = gql`
  mutation AskAssistant(
    $question: String!
    $conversationId: SmartID
    $projectId: SmartID
  ) {
    askAssistant(
      question: $question
      conversationId: $conversationId
      projectId: $projectId
    ) {
      success
      message
      conversation {
        id
        isAwaitingTeam
        messages {
          ...AssistantMessageFields
        }
      }
    }
  }
  ${ASSISTANT_MESSAGE_FIELDS}
`;

export const ASSISTANT_ANSWER_SUBSCRIPTION = gql`
  subscription AssistantAnswer($conversationId: SmartID!) {
    assistantAnswer(conversationId: $conversationId)
  }
`;

export const ASSISTANT_PROGRESS_SUBSCRIPTION = gql`
  subscription AssistantProgress($conversationId: SmartID!) {
    assistantProgress(conversationId: $conversationId)
  }
`;

export const ASSISTANT_REVIEW_COUNT_QUERY = gql`
  query AssistantEscalationsForReviewCount {
    assistantEscalationsForReviewCount
  }
`;

export const ASSISTANT_ESCALATIONS_QUERY = gql`
  query AssistantEscalationsForReview {
    assistantEscalationsForReview {
      id
      status
      question
      reason
      shotName
      draftAnswer
      created
      project {
        id
        name
      }
      askedBy {
        id
        firstName
        lastName
        email
      }
    }
  }
`;

export const ASSISTANT_ESCALATION_TRANSCRIPT_QUERY = gql`
  query AssistantEscalationTranscript($escalationId: SmartID!) {
    assistantEscalationTranscript(escalationId: $escalationId) {
      ...AssistantMessageFields
    }
  }
  ${ASSISTANT_MESSAGE_FIELDS}
`;

export const REVIEW_ASSISTANT_ESCALATION_MUTATION = gql`
  mutation ReviewAssistantEscalation(
    $escalationId: SmartID!
    $action: String!
    $message: String
  ) {
    reviewAssistantEscalation(
      escalationId: $escalationId
      action: $action
      message: $message
    ) {
      success
      message
      escalation {
        id
        status
        reviewedAt
      }
    }
  }
`;

export const ASSISTANT_ESCALATION_SUBSCRIPTION = gql`
  subscription AssistantEscalation {
    assistantEscalation
  }
`;
